var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBestRated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.78164 2.75605C0.78164 1.40937 1.85898 0.293554 3.24414 0.293554H15.5566C16.9033 0.293554 18.0191 1.40937 18.0191 2.75605V15.0686C18.0191 16.4537 16.9033 17.5311 15.5566 17.5311H3.24414C1.85898 17.5311 0.78164 16.4537 0.78164 15.0686V2.75605ZM9.40039 3.06387C9.13105 3.06387 8.93867 3.21777 8.82324 3.41016L7.43809 6.25742L4.32148 6.71914C4.09062 6.71914 3.89824 6.91152 3.82129 7.10391C3.74434 7.33477 3.82129 7.6041 3.97519 7.75801L6.24531 9.95117L5.70664 13.0678C5.66816 13.2986 5.74512 13.5295 5.9375 13.6449C6.12988 13.7988 6.39922 13.7988 6.5916 13.7219L9.40039 12.2598L12.1707 13.7219C12.3631 13.7988 12.6324 13.7988 12.8248 13.6449C13.0172 13.5295 13.0941 13.2986 13.0557 13.0678L12.517 9.95117L14.7871 7.75801C14.941 7.6041 15.018 7.33477 14.941 7.14238C14.8641 6.91152 14.6717 6.75762 14.4408 6.71914L11.3242 6.25742L9.93906 3.41016C9.82363 3.21777 9.63125 3.10234 9.40039 3.10234V3.06387Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestRated);
export default ForwardRef;